import React, { useEffect, useRef, useState } from "react";
import { CropImage } from "../models/common/ICropImage";
import ReactCrop, { Crop } from "react-image-crop";
import "react-image-crop/src/ReactCrop.scss";

const CropComponent = (props: CropImage) => {
  const { onCropComplete, onClose, initialImage } = props;
  const [src, setSrc] = useState<string | null>(null);
  const [crop, setCrop] = useState<Crop>({
    unit: "px",
    width: 383,
    height: 263,
    x: 0,
    y: 0,
  });
  const imageRef = useRef<HTMLImageElement | null>(null);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  // const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   if (e.target.files && e.target.files.length > 0) {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(e.target.files[0]);
  //     reader.onload = () => setSrc(reader.result as string);
  //   }
  // };

  const getCroppedImage = () => {
    if (!imageRef.current || !canvasRef.current || !crop.width || !crop.height)
      return;

    const image = imageRef.current;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    if (!ctx) return;

    // Calculate crop dimensions
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const cropX = crop.x * scaleX;
    const cropY = crop.y * scaleY;
    const cropWidth = crop.width * scaleX;
    const cropHeight = crop.height * scaleY;

    canvas.width = cropWidth;
    canvas.height = cropHeight;

    ctx.drawImage(
      image,
      cropX,
      cropY,
      cropWidth,
      cropHeight,
      0,
      0,
      cropWidth,
      cropHeight
    );

    // Convert to File
    canvas.toBlob((blob) => {
      if (!blob) return;
      const croppedFile = new File([blob], "cropped-image.png", {
        type: "image/png",
      });
      onCropComplete(croppedFile);
    }, "image/png");

    onClose();
  };

  useEffect(() => {
    if (initialImage) {
      const reader = new FileReader();
      reader.readAsDataURL(initialImage);
      reader.onload = () => setSrc(reader.result as string);
    }
  }, [initialImage]);

  return (
    <div className="cropping-wrap">
      {/* <div className="img-upload form-group w-50">
      <input className="form-control" type="file" accept="image/*" onChange={handleFileChange} />
      </div> */}
      {src && (
        <div className="cropping-container">
          <ReactCrop
            crop={crop}
            minHeight={263}
            minWidth={383}
            aspect={383 / 263}
            onChange={(newCrop) => setCrop(newCrop)}
          >
            <img ref={imageRef} src={src} alt="Crop me" />
          </ReactCrop>
          <div className="d-flex gap-2 mt-2">
          <button className="btn btn-primary" onClick={getCroppedImage}>Crop Image</button>
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          </div>
        </div>
      )}
      <canvas ref={canvasRef} style={{ display: "none" }} />
    </div>
  );
};

export default CropComponent;
